module.exports = __webpack_public_path__ + "static/media/logowithoutback.20042b0b.png";